import React from 'react';
import SignInForm from './SignInForm';

const LoginPage = () => {
  return <SignInForm />;
};

export default LoginPage;
